import { apiClient, ApiResponse } from './client';

export type MomentumLabel = 'surging' | 'rising' | 'stable' | 'declining' | 'crashing';

export interface HealthScore {
  overall: number;
  diversification: number;
  liquidity: number;
  momentum: number;
  valueAtRisk: number;
}

export interface CollectionHolding {
  collection_id: string;
  collection_name: string;
  collection_slug: string | null;
  thumbnail_url: string | null;
  count: number;
  floor_price: number | null;
  estimated_value: number;
  weight: number;
  momentum_score: number;
  momentum_label: MomentumLabel;
}

export interface ConcentrationAlert {
  collection_name: string;
  collection_id: string;
  weight: number;
  momentum_label: MomentumLabel;
  severity: 'warning' | 'critical';
  message: string;
}

export interface PortfolioSummary {
  total_nfts: number;
  total_estimated_value: number;
  total_floor_value: number;
  unique_collections: number;
  health_score: HealthScore;
  holdings: CollectionHolding[];
  concentration_alerts: ConcentrationAlert[];
  top_gainers: CollectionHolding[];
  top_losers: CollectionHolding[];
}

export interface MarketOverview {
  total_volume_24h: number;
  total_sales_24h: number;
  active_collections: number;
  avg_momentum: number;
  market_sentiment: 'bullish' | 'neutral' | 'bearish';
}

export interface MarketPulseCollection {
  collection_id: string;
  collection_name: string;
  collection_slug: string | null;
  thumbnail_url: string | null;
  floor_price: number | null;
  floor_change_24h: number;
  volume_24h: number;
  volume_7d: number;
  sales_24h: number;
  total_supply: number;
  listed_count: number;
  listed_ratio: number;
  momentum_score: number;
  momentum_label: MomentumLabel;
  signal: string;
}

export interface MarketPulseData {
  overview: MarketOverview;
  surging: MarketPulseCollection[];
  rising: MarketPulseCollection[];
  declining: MarketPulseCollection[];
  crashing: MarketPulseCollection[];
  highest_volume: MarketPulseCollection[];
  newly_active: MarketPulseCollection[];
}

export async function getPortfolioIntelligence(): Promise<ApiResponse<PortfolioSummary>> {
  return apiClient.get<ApiResponse<PortfolioSummary>>('/intelligence/portfolio');
}

export async function getWalletIntelligence(address: string): Promise<ApiResponse<PortfolioSummary>> {
  return apiClient.get<ApiResponse<PortfolioSummary>>(`/intelligence/portfolio/${encodeURIComponent(address)}`);
}

export async function getMarketPulse(): Promise<ApiResponse<MarketPulseData>> {
  return apiClient.get<ApiResponse<MarketPulseData>>('/intelligence/market-pulse');
}
